export const countryReducer = (state = {}, action) => {
  // reducer
  switch (action.type) {
    case "GET_COUNTRY_LIST_REQUEST": 
      return { ...state, loading: true, countryList: null };
    case "GET_COUNTRY_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        countryList: action.payload,
      };
    case "GET_COUNTRY_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_COUNTRY_REQUEST":
      return {
        ...state,
        loading: true,
        country: null,
      };
    case "GET_COUNTRY_SUCCESS":
      return {
        ...state,
        loading: false,
        country: action.payload,
      };
    case "GET_COUNTRY_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "SET_FETCHED_TIME":
      return {
        ...state,
        lastFetched: action.payload,
      };
    case "ADD_COUNTRY_REQUEST":
      return {
        ...state,
        loading: false,
        countryList: null,
        isAdded: false,
      };
    case "ADD_COUNTRY_SUCCESS":
      return {
        ...state,
        loading: false,
        isAdded: true,
        countryList: action.payload,
      };
    case "ADD_COUNTRY_FAIL":
      return {
        ...state,
        loading: false,
        isAdded: false,
        error: action.payload,
      };

    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

export const stateReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_STATE_REQUEST":
      return {
        loading: true,
        data: null,
        isAdded: false,
      };
    case "ADD_STATE_SUCCESS":
      return {
        loading: false,
        data: action.payload,
        isAdded: true,
      };
    case "ADD_STATE_FAIL":
      return {
        loading: false,
        error: action.payload,
        isAdded: false,
      };
    case "GET_STATE_REQUEST":
      return {
        ...state,
        loading: true,
        stateData: null,
      };
    case "GET_STATE_SUCCESS":
      return {
        ...state,
        loading: false,
        stateData: action.payload,
      };
    case "GET_STATE_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "GET_STATE_LIST_REQUEST":
      return {
        loading: true,
        states: null,
      };

    case "GET_STATE_LIST_SUCCESS":
      return {
        ...state,

        loading: false,
        states: action.payload,
      };

    case "GET_STATE_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "SET_FETCHED_TIME":
      return {
        ...state,
        lastFetched: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};

// export const cityReducer = (state = {}, action) => {
//   switch (action.type) {
//     case "ADD_CITY_REQUEST":
//       return {
//         loading: true,
//         data: null,
//         isAdded: false,
//       };
//     case "ADD_CITY_SUCCESS":
//       return {
//         loading: false,
//         data: action.payload,
//         isAdded: true,
//       };
//     case "ADD_CITY_FAIL":
//       return {
//         loading: false,
//         error: action.payload,
//         isAdded: false,
//       };
//     case "SET_FETCH_TIME":
//       return {
//         ...state,
//         lastFetched: action.payload,
//       };
//     case "GET_CITY_LIST_REQUEST":
//       return {
//         loading: true,
//         cities: null,
//       };
//     case "GET_CITY_LIST_SUCCESS":
//       return {
//         ...state,
//         loading: false,
//         cities: action.payload,
//       };
//     case "GET_CITY_LIST_FAIL":
//       return {
//         loading: false,
//         error: action.payload,
//       };
//     case "EDIT_CITY_REQUEST":
//       return {
//         ...state,
//         loading: true,
//         data: null,
//         isAdded: false,
//       };
//     case "EDIT_CITY_SUCCESS":
//       return {
//         ...state,
//         loading: false,
//         data: action.payload,
//         isAdded: true,
//       };
//     case "EDIT_CITY_FAIL":
//       return {
//         ...state,
//         loading: false,
//         error: action.payload,
//         isAdded: false,
//       };
//     case "CLEAR_ERRORS":
//       return {
//         ...state,
//         error: null,
//       };
//     default:
//       return state;
//   }
// };


export const cityReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_ALL_CITY_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        citiesList: null,
      };
    case "GET_ALL_CITY_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        citiesList: action.payload,
      };
    case "GET_ALL_CITY_LIST_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "ADD_CITY_REQUEST":
      return {
        ...state,
        loading: true,
        data: null,
        isAdded: false,
      };
    case "ADD_CITY_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        isAdded: true,
      };
    case "ADD_CITY_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        isAdded: false,
      };
    case "EDIT_CITY_REQUEST":
      return {
        ...state,
        loading: true,
        data: null,
        isAdded: false,
      };
    case "EDIT_CITY_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
        isAdded: true,
      };
    case "EDIT_CITY_FAIL":
      return {
        ...state,
        loading: false,
        error: action.payload,
        isAdded: false,
      };
    case "SET_FETCH_TIME":
      return {
        ...state,
        lastFetched: action.payload,
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};